export interface IDialog {
	valid?: boolean;
	visible?: boolean;
	formRef?: string;
	headline: string;
	message?: string;
	okText?: string;
	closeText?: string;
	isInfoDialog?: boolean;
	hasCloseBtn?: boolean;
	isModal?: boolean;
	useTextArea?: boolean;
	cancelText?: string;
	hasCancelBtn?: boolean;
	values?: DialogValue[];
	text?: string;
	showReplaceCheckbox?: boolean;

	ok?: () => void;
	close?: () => void;
	cancel?: () => void;
	cleanUp?: () => void;
	fixString?: (checked: boolean) => void;

	// Whatever data is needed for the dialog
	metaInformation?: any;
}

export class Dialog implements IDialog {
	valid?: boolean;
	visible: boolean;
	formRef?: string;
	headline: string;
	message?: string;
	okText?: string;
	closeText?: string;
	isInfoDialog?: boolean;
	hasCloseBtn?: boolean;
	isModal?: boolean;
	useTextArea?: boolean;
	cancelText?: string;
	hasCancelBtn?: boolean;
	values?: DialogValue[];
	text?: string;
	showReplaceCheckbox?: boolean;

	ok(): void {
		this.cleanUp();
	}

	close(): void {
		this.cleanUp();
	}

	cancel(): void {
		this.cleanUp();
	}

	cleanUp(): void {
		this.baseCleanup();
	}
	fixString(checked: boolean): void {}

	baseCleanup(): void {
		this.visible = false; //Hide popup
		this.valid = true; //Reset validation

		if (this.values && this.values.length > 0) {
			//Reset values
			for (var i = 0; i < this.values.length; i++) {
				this.values[i].value = '';
				this.values[i].errorMessages = '';
			}
		}
	}

	metaInformation?: any;

	constructor();
	constructor(obj: IDialog);
	constructor(obj?: IDialog) {
		this.valid = obj && obj.valid != undefined ? obj.valid : true;
		this.visible = obj && obj.visible != undefined ? obj.visible : false;
		this.formRef = (obj && obj.formRef) || undefined;
		this.headline = (obj && obj.headline) || '';
		this.message = (obj && obj.message) || '';
		this.okText = (obj && obj.okText) || undefined;
		this.closeText = (obj && obj.closeText) || undefined;
		this.isInfoDialog =
			obj && obj.isInfoDialog != undefined ? obj.isInfoDialog : false;
		this.hasCloseBtn =
			obj && obj.hasCloseBtn != undefined ? obj.hasCloseBtn : false;
		this.isModal =
			obj && obj.isModal != undefined ? obj.isModal : false;
		this.useTextArea =
			obj && obj.useTextArea != undefined ? obj.useTextArea : false;
		this.cancelText = (obj && obj.cancelText) || undefined;
		this.hasCancelBtn =
			obj && obj.hasCancelBtn != undefined ? obj.hasCancelBtn : true;
		this.values = (obj && obj.values) || undefined;
		this.text = (obj && obj.text) || undefined;
		this.metaInformation = (obj && obj.metaInformation) || undefined;
		this.showReplaceCheckbox =
			obj && obj.showReplaceCheckbox != undefined
				? obj.showReplaceCheckbox
				: false;

		if (obj && typeof obj.ok === 'function') {
			this.ok = obj.ok;
		}

		if (obj && typeof obj.close === 'function') {
			this.close = obj.close;
		}

		if (obj && typeof obj.cancel === 'function') {
			this.cancel = obj.cancel;
		}

		if (obj && typeof obj.cleanUp === 'function') {
			this.cleanUp = obj.cleanUp;
		}

		if (obj && typeof obj.fixString === 'function') {
			this.fixString = obj.fixString;
		}
	}
}

export class DialogValue implements IDialogValue {
	type: string;
	enumItems?: { key: number; value: string }[];
	id: string;
	label: string;
	value?: any;
	rules?: any[];
	errorMessages?: string;

	customValidation(): void {
		return;
	}

	display: boolean;
	disable: boolean;

	displayChange(): void {
		return;
	}

	constructor();
	constructor(obj: IDialogValue);
	constructor(obj?: IDialogValue) {
		this.type = obj.type || undefined;
		this.enumItems = obj.enumItems || undefined;
		this.id = obj.id || undefined;
		this.label = obj.label || undefined;
		this.value = obj.value || undefined;
		this.rules = obj.rules || undefined;
		this.errorMessages = obj.errorMessages || undefined;

		this.display = obj && obj.display != undefined ? obj.display : true;

		this.disable = obj && obj.disable != undefined ? obj.disable : false;

		if (obj && typeof obj.displayChange === 'function') {
			this.displayChange = obj.displayChange;
		}

		if (obj && typeof obj.customValidation === 'function') {
			this.customValidation = obj.customValidation;
		}
	}
}

export interface IDialogValue {
	type: string;
	enumItems?: { key: number; value: string }[];
	id: string;
	label: string;
	value?: any;
	rules?: any[];
	display?: boolean;
	disable?: boolean;
	displayChange?: () => void;
	customValidation?: () => void;
	errorMessages?: string;
}

export enum DialogValueTypeEnum {
	text = 'text',
	textarea = 'textarea',
	number = 'number',
	enum = 'enum',
	users = 'users',
	autocomplete = 'autocomplete',
	boolean = 'boolean',
	image = 'img',
	video = 'video',
}
